import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Settings() {
  const navigate = useNavigate();
  
  const settingsMenu = [
    {
      id: 'order-consolidation',
      title: '📈 Order Consolidation',
      description: 'Manage weekly order consolidation and approval workflow',
      path: '/order-consolidation'
    },
    {
      id: 'duplicate-settings',
      title: '🔄 Duplicate Order Settings',
      description: 'Configure duplicate order detection and warnings',
      path: '/duplicate-settings'
    },
    {
      id: 'product-requests',
      title: '📦 Product Requests',
      description: 'Review and manage staff product requests',
      path: '/manage-product-requests'
    }
  ];

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      <div style={{ marginBottom: '30px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '10px' }}>
          ⚙️ Settings
        </h1>
        <p style={{ color: '#666' }}>Manage system configuration</p>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '20px'
      }}>
        {settingsMenu.map(item => (
          <div
            key={item.id}
            onClick={() => navigate(item.path)}
            style={{
              background: 'white',
              padding: '25px',
              borderRadius: '16px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              border: '2px solid transparent'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              e.currentTarget.style.borderColor = '#667eea';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
              e.currentTarget.style.borderColor = 'transparent';
            }}
          >
            <div style={{
              fontSize: '40px',
              marginBottom: '15px'
            }}>
              {item.title.split(' ')[0]}
            </div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              marginBottom: '10px',
              color: '#333'
            }}>
              {item.title.substring(item.title.indexOf(' ') + 1)}
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#666',
              lineHeight: '1.5'
            }}>
              {item.description}
            </p>
            <div style={{
              marginTop: '15px',
              color: '#667eea',
              fontSize: '14px',
              fontWeight: '600'
            }}>
              Configure →
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Settings;
